import cxs from 'cxs';
import { COLOURS } from '../../../common/styles/vars';

export const CLOSABLE_PAGE = ({ backgroundImage }) => cxs({
  background: COLOURS.mono.white,
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  left: '0',
  position: 'fixed',
  top: '0',
  width: '100vw',
  backgroundImage: backgroundImage ? `url(${backgroundImage})` : void 0,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  zIndex: 10,
  overflowY: 'auto'
});

export const CONTENT = cxs({
  paddingTop: '125px'
});